import { formatCurrency } from '../../helpers'
import { ProgressBar } from '../progressBar'
import { ChartCard } from './ChartCard'

const BAR_COLORS = ['!bg-lime-green', '!bg-primary', '!bg-red-650', '!bg-amber']

export type ChannelEntry = {
  label: string
  amount: number
  orderCount: number
  creatorCount?: number
  subItems?: { label: string; amount: number; orderCount: number }[]
}

export const ChannelBreakdownCard = ({
  title,
  entries,
}: {
  title: string
  entries: ChannelEntry[]
}) => {
  const totalAmount = entries.reduce((acc, e) => acc + e.amount, 0)

  return (
    <ChartCard title={title} value={formatCurrency(totalAmount)}>
      {entries.map((entry, idx) => (
        <div
          key={idx}
          className="flex flex-col gap-2 py-4 border-b border-divider-gray last:border-b-0 last:pb-0"
        >
          <p>{entry.label}</p>

          <p className="text-default-gray flex items-center gap-2">
            <span>{formatCurrency(entry.amount)}</span>
            <span className="font-black text-xl">·</span>
            <span>{entry.orderCount} Orders</span>
            {entry.creatorCount ? (
              <>
                <span className="font-black text-xl">·</span>
                <span>{entry.creatorCount} Creators</span>
              </>
            ) : null}
          </p>

          <ProgressBar
            step={entry.amount}
            total={totalAmount}
            singleBarClassName={BAR_COLORS[idx % BAR_COLORS.length]}
            showPercent
          />

          {(entry.subItems?.length ?? 0) > 0 && (
            <ul className="text-gray-500 list-disc list-outside pl-4">
              {entry.subItems!.map((item, i) => (
                <li key={i}>
                  <div className="text-sm flex flex-row items-center gap-1 justify-between flex-wrap">
                    <p className="w-full text-base text-sec-black">
                      {item.label}
                    </p>
                    <span>{formatCurrency(item.amount)}</span>
                    <span>{item.orderCount} orders</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </ChartCard>
  )
}
